var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ 'padding-top': _vm.offsetHeight + 'px' })},[_c('van-nav-bar',{ref:"navBar",attrs:{"fixed":true,"title":"已兑换私房课","left-text":"返回","left-arrow":""},on:{"click-left":_vm.onClickLeft}}),_c('div',[_vm._v("已兑换私房课")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }